{
	"title": "Para support",
	"subtitle": "Guide runners, pilots, ramp assistants and sighted directors, and the para athletes they support in {{games}}.",
	"link": "Link support person",
	"roles": {
		"GUIDE": "Guide",
		"PILOT": "Pilot",
		"RAMP_ASSISTANT": "Ramp assistant",
		"SIGHTED_DIRECTOR": "Sighted director",
		"OTHER": "Other"
	},
	"refusals": {
		"NOT_FOUND": "This card no longer exists.",
		"OTHER_GAMES": "This card belongs to another games.",
		"SAME_PERSON": "A person cannot support themselves.",
		"ALREADY_LINKED": "Already linked to this athlete."
	},
	"filters": {
		"label": "Filter support links",
		"name": "Athlete or support person",
		"noc": "NOC",
		"allNocs": "All NOCs",
		"sport": "Sport",
		"allSports": "All sports",
		"role": "Role",
		"anyRole": "Any role"
	},
	"table": {
		"athlete": "Athlete",
		"sports": "Sport",
		"noc": "NOC",
		"support": "Support person",
		"role": "Role",
		"linkedOn": "Linked on",
		"count_one": "{{n}} link",
		"count_other": "{{n}} links",
		"addAnother": "Add another support person for {{name}}",
		"remove": "Remove {{support}} from {{athlete}}",
		"allSports": "Every sport",
		"noSport": "No sport"
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"empty": {
		"noGamesTitle": "No games yet",
		"noGamesBody": "There is no games to show support links for.",
		"notParaTitle": "Support links are for the Para games",
		"notParaBody": "{{games}} is not a para games. Switch to the Para games with the games switch at the top of the sidebar.",
		"filteredTitle": "No link matches these filters",
		"filteredBody": "Try fewer filters, or reset them.",
		"reset": "Reset filters",
		"noneTitle": "No support links in {{games}} yet",
		"noneBody": "Link a guide, pilot, ramp assistant or sighted director to the para athlete they support.",
		"noneBodyReader": "A super admin links support people to the para athletes they support.",
		"forbiddenTitle": "You cannot see support links",
		"forbiddenBody": "Your role does not include para support links. Ask an administrator if you need them.",
		"gamesTitle": "Couldn't load the games"
	},
	"remove": {
		"title": "Remove this support link?",
		"body": "{{support}} will no longer be linked to {{athlete}}. Their entries and results do not change.",
		"confirm": "Remove link",
		"done": "Support link removed."
	},
	"drawer": {
		"title": "Link support person",
		"step1": "1. Find the athlete",
		"step2": "2. Pick the support people",
		"athleteSearch": "Athlete name or card number",
		"supportSearch": "Support person name or card number",
		"typeToSearch": "Type a name to search.",
		"searching": "Searching…",
		"noMatches": "No card matches “{{query}}”.",
		"tooMany": "Showing the first {{n}} — type more of the name to narrow it.",
		"searchError": "Couldn't search the cards.",
		"nocFilter": "NOC",
		"anyNoc": "Any NOC",
		"pick": "Pick",
		"change": "Change athlete",
		"onlyNoc": "Only {{noc}}",
		"onlyNocNone": "Only the athlete's NOC",
		"existing": "Already linked",
		"noExisting": "No support person linked yet.",
		"selected_one": "{{n}} selected",
		"selected_other": "{{n}} selected",
		"max": "At most {{n}} at a time.",
		"role": "Role",
		"submit_one": "Link {{n}} person",
		"submit_other": "Link {{n}} people",
		"linked_one": "{{n}} support person linked.",
		"linked_other": "{{n}} support people linked.",
		"noneLinked": "Nobody was linked.",
		"refusedTitle": "Not linked",
		"cancel": "Cancel",
		"done": "Done",
		"pickAthleteFirst": "Pick the athlete first."
	}
}
